import {createReducer} from '../utility'




export const membership = createReducer({},{
    "INDIVIDUAL_MEMBERSHIP_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                application: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})

export const hasEditedMembership = createReducer({},{
    "HAS_EDITED_MEMBERSHIP"(state, {data}){
        if(data){
            return {
                ...state,
                edited: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})